module.exports = __webpack_public_path__ + "img/card-new-member.5283421a.png";